module.exports = [
    { text: "Amount", value: "amount" },
    { text: "Percentage", value: "percentage" },
];